import { createSlice } from "@reduxjs/toolkit";
import { GenrateRxLink } from "../../apis/dispense/genrateRxLink";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const GenrateRxLinkSlice = createSlice({
    name: 'GenrateRxLink',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(GenrateRxLink.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(GenrateRxLink.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(GenrateRxLink.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default GenrateRxLinkSlice.reducer